import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs';
import { Utils } from '@app/_core/helper/Utils';

import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService
  ) {}

  setUserDetails(data: any) {
    let pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.capResults = true;
    pl.company = company;
    pl = { ...pl, ...data };
    return pl;
  }

  saveFile(file) {
    let pl: any = {};
    pl = this.setUserDetails(file);
    pl = JSON.parse(JSON.stringify(pl));
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/privateFiles/SaveFile`, pl).pipe(
      // return this.http.post<any>(`${environment.apiUrl}api/privateFiles/SaveFile`, pl).pipe(
      map(res => {
        this.loaderService.display(false);

        res = {
          Response: {
            Data: {
              FileID: 1411,
              FileTypeID: 20,
              Name: 'Onvida_QA1_2023-02-09_107_RanjithKumar_Voicemail.mp3',
              Description: null,
              Size: 7628,
              URL: 'https://s3.amazonaws.com/onvida-hr1-public-prod/files/1411/Onvida_QA1_2023-02-09_107_RanjithKumar_Voicemail.mp3',
              Disabled: false,
              Created: '/Date(1698766774290)/',
              LastUpdated: '/Date(-62135578800000)/',
              CreatedBy: 3331,
              UpdatedBy: 3331,
              FileType: {
                FileTypeID: 20,
                FileTypeGroupID: 4,
                FileTypeGroupName: 'Audio',
                Name: 'MP3 Audio',
                ShortName: 'MP3',
                AbbreviatedName: null,
                Description: 'MPEG 3 Audio Format',
                ContentType: 'audio/mpeg',
                Extensions: ['mp3'],
              },
              Creator: {
                UserID: 3331,
                Email: 'praveenraj.manoharan@cognizant.com',
                FirstName: 'Praveenraj',
                LastName: 'Manoharan',
                GlobalRole: {
                  RoleID: 7,
                  AuthLevel: 5,
                  Name: 'ClientAdmin',
                  Grants: [
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 2,
                      Name: 'Admin',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 5,
                      Name: 'ManageUsers',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 9,
                      Name: 'Reporting',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 10,
                      Name: 'Preview',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 11,
                      Name: 'ApproveContent',
                    },
                  ],
                },
                Grants: [
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 1,
                    Name: 'TM',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 2,
                    Name: 'Admin',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 5,
                    Name: 'ManageUsers',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 6,
                    Name: 'Twilio',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 9,
                    Name: 'Reporting',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 15,
                    Name: 'AuditAgents',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 16,
                    Name: 'ManageAgents',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 22,
                    Name: 'ManageIVR',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 23,
                    Name: 'ManageCampaigns',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 24,
                    Name: 'ManageAssignments',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 25,
                    Name: 'LiveView',
                  },
                ],
                AvatarLocation: null,
                PhoneNumbers: [
                  {
                    PhoneNumberID: 1062,
                    Number: '0000000000',
                    StrippedNumber: '0000000000',
                    Type: 'Business',
                  },
                ],
              },
              Updater: {
                UserID: 3331,
                Email: 'praveenraj.manoharan@cognizant.com',
                FirstName: 'Praveenraj',
                LastName: 'Manoharan',
                GlobalRole: {
                  RoleID: 7,
                  AuthLevel: 5,
                  Name: 'ClientAdmin',
                  Grants: [
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 2,
                      Name: 'Admin',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 5,
                      Name: 'ManageUsers',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 9,
                      Name: 'Reporting',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 10,
                      Name: 'Preview',
                    },
                    {
                      GlobalGrantID: 0,
                      ClientGrantID: 11,
                      Name: 'ApproveContent',
                    },
                  ],
                },
                Grants: [
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 1,
                    Name: 'TM',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 2,
                    Name: 'Admin',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 5,
                    Name: 'ManageUsers',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 6,
                    Name: 'Twilio',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 9,
                    Name: 'Reporting',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 15,
                    Name: 'AuditAgents',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 16,
                    Name: 'ManageAgents',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 22,
                    Name: 'ManageIVR',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 23,
                    Name: 'ManageCampaigns',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 24,
                    Name: 'ManageAssignments',
                  },
                  {
                    GlobalGrantID: 0,
                    ClientGrantID: 25,
                    Name: 'LiveView',
                  },
                ],
                AvatarLocation: null,
                PhoneNumbers: [
                  {
                    PhoneNumberID: 1062,
                    Number: '0000000000',
                    StrippedNumber: '0000000000',
                    Type: 'Business',
                  },
                ],
              },
              Attributes: [],
            },
            Status: 1,
            Message: null,
          },
          Status: 1,
          Message: null,
        };
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
}
